import { SITE_ORIGIN } from "./site.config";

export type SeoSlug = "como" | "mensagem" | "gerador" | "como-es" | "mensaje-es" | "generador-es" | "como-en" | "message-en" | "generator-en";

export interface SeoPageConfig {
  title: string;
  description: string;
  path: string;
  ogTitle: string;
  ogDescription: string;
}

export const SEO_STATIC_PAGES: Record<SeoSlug, SeoPageConfig> = {
  como: {
    title: "Como criar link do WhatsApp (guia) | WhatsMeApp",
    description: "Aprenda a criar link wa.me com código do país, exemplos e mensagem com ?text=. Use nosso gerador gratuito.",
    path: "/como-criar-link-whatsapp",
    ogTitle: "Como criar link do WhatsApp (guia completo)",
    ogDescription: "Formato https://wa.me/SEUNUMERO, exemplos e mensagem automática com ?text=.",
  },
  mensagem: {
    title: "Link WhatsApp com mensagem automática | WhatsMeApp",
    description: "Gere links wa.me com mensagem pronta (?text=). Exemplos e ferramenta gratuita para copiar e compartilhar.",
    path: "/link-whatsapp-com-mensagem",
    ogTitle: "Gerar link WhatsApp com mensagem automática",
    ogDescription: "Crie links de WhatsApp já com mensagem pronta em segundos.",
  },
  gerador: {
    title: "Gerador de link WhatsApp grátis | WhatsMeApp",
    description: "Gerador gratuito de links wa.me com mensagem opcional. Funciona no celular e desktop.",
    path: "/gerador-link-whatsapp-gratis",
    ogTitle: "Gerador de link WhatsApp grátis",
    ogDescription: "Crie links de WhatsApp personalizados rapidamente: mensagem automática, mobile e desktop.",
  },
  "como-es": {
    title: "Cómo crear enlace de WhatsApp (guía) | WhatsMeApp",
    description: "Aprende a crear un enlace wa.me con código de país, ejemplos y mensaje con ?text=. Usa nuestro generador gratuito.",
    path: "/como-crear-enlace-whatsapp",
    ogTitle: "Cómo crear enlace de WhatsApp (guía completa)",
    ogDescription: "Formato https://wa.me/TUNUMERO, ejemplos y mensaje automático con ?text=.",
  },
  "mensaje-es": {
    title: "Enlace WhatsApp con mensaje automático | WhatsMeApp",
    description: "Genera enlaces wa.me con mensaje listo (?text=). Ejemplos y herramienta gratuita para copiar y compartir.",
    path: "/enlace-whatsapp-con-mensaje",
    ogTitle: "Generar enlace WhatsApp con mensaje automático",
    ogDescription: "Crea enlaces de WhatsApp ya con mensaje listo en segundos.",
  },
  "como-en": {
    title: "How to Create a WhatsApp Link (guide) | WhatsMeApp",
    description: "Learn how to create a wa.me link with country code, examples and message with ?text=. Use our free generator.",
    path: "/how-to-create-whatsapp-link",
    ogTitle: "How to Create a WhatsApp Link (complete guide)",
    ogDescription: "Format https://wa.me/YOURNUMBER, examples and automatic message with ?text=.",
  },
  "message-en": {
    title: "WhatsApp Link with Auto Message | WhatsMeApp",
    description: "Generate wa.me links with a preset message (?text=). Examples and free tool to copy and share.",
    path: "/whatsapp-link-with-message",
    ogTitle: "Generate WhatsApp Link with Auto Message",
    ogDescription: "Create WhatsApp links with a preset message ready in seconds.",
  },
  "generator-en": {
    title: "Free WhatsApp Link Generator | WhatsMeApp",
    description: "Free wa.me link generator with optional message. Works on mobile and desktop.",
    path: "/free-whatsapp-link-generator",
    ogTitle: "Free WhatsApp Link Generator",
    ogDescription: "Create custom WhatsApp links quickly: auto message, mobile and desktop.",
  },
  "generador-es": {
    title: "Generador de enlace WhatsApp gratis | WhatsMeApp",
    description: "Generador gratuito de enlaces wa.me con mensaje opcional. Funciona en móvil y escritorio.",
    path: "/generador-enlace-whatsapp-gratis",
    ogTitle: "Generador de enlace WhatsApp gratis",
    ogDescription: "Crea enlaces de WhatsApp personalizados rápidamente: mensaje automático, móvil y escritorio.",
  },
};

export function canonicalUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_ORIGIN}${p}`;
}
